
const VERSION = {
  SHA1:'d6b195b7f4a0be2bae3fd5a5f22c6951473dffb9',
  VERSION:2322,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
